import * as defaults from "./constants/defaults";
import { environment } from "./build_environment";

// -----------------------
//       next-dev DEV
// -----------------------
const config_dev = {
  userPoolId: "us-east-1_4CH8VE67K",
  region: "us-east-1",
  userPoolWebClientId: "31nkjmuco3hf3032ri82arcn2q",
  // identityPoolId: "us-east-1:c829f4b8-72e6-4dca-b846-2668e9b08a82",
  oauth: {
    domain: "afinandonextdev.auth.us-east-1.amazoncognito.com/",
    // redirectSignIn: "http://localhost:3000",
    // redirectSignOut: "http://localhost:3000",
    // redirectSignIn:"https://nextdev.afinandoocerebro.com.br/login?addlogin=true",
    // redirectSignOut:"https://nextdev.afinandoocerebro.com.br/login?addlogin=true",
    responseType: "code",
  },
};

// -----------------------
//       next-dev PROD
// -----------------------
const config_prod = {
  userPoolId: "us-east-1_BFgpppTHT",
  region: "us-east-1",
  userPoolWebClientId: "227p04lnatr02u8svubl0fpl76",
  oauth: {
    domain: "auth.afinandoocerebro.com.br/",
    // redirectSignIn: "https://novo.afinandoocerebro.com.br/login",
    // redirectSignOut: "https://novo.afinandoocerebro.com.br/login",
    responseType: "code",
  },
};

export const RUNNING_ENVIROMENT = environment;

const config = environment === defaults.DEV ? config_dev : config_prod;
config["Heimdall"] = config.userPoolWebClientId + "Ddak#eir&D8AFukAFSD";

export default config;
